<template>
  <Row>
    <Row type="flex" justify="end" style="margin:12px 0">
      <Page
        :current="page.current"
        show-total
        :total="page.total"
        size="small"
        @on-change="changePage"
        show-sizer
        :page-size="page.limit"
        @on-page-size-change="changeLimit"
        :page-size-opts="[10, 20, 30, 40, 50, 60, 80]"
      >
      </Page>
      <i-button size="small" @click="download">
        <FFIcon type="download" aria-hidden="true" />
        download
      </i-button>
    </Row>

    <Row>
      <i-table
        size="small"
        :data="dataset"
        :columns="columns"
        @on-sort-change="sortTable"
      >
      </i-table>
    </Row>

    <Row type="flex" justify="end" style="margin:12px 0">
      <Page
        :current="page.current"
        show-total
        show-sizer
        :total="page.total"
        size="small"
        @on-change="changePage"
        :page-size="page.limit"
        @on-page-size-change="changeLimit"
        :page-size-opts="[10, 20, 30, 40, 50, 60, 80]"
      >
      </Page>
      <i-button size="small" @click="download">
        <FFIcon type="download" aria-hidden="true" />
        download
      </i-button>
    </Row>
  </Row>
</template>

<script>
import tableActions from "@/mixins/table_actions.js";
import pagination from "@/mixins/pagination.js";
import sort from "@/mixins/sort.js";
import { getDatasetsByConditions } from "@/models/Dataset.ts";

export default {
  mixins: [tableActions, pagination, sort],
  props: ["conditions", "limit"],

  data() {
    return {
      tableURL: "tabular_datasets",
      dataset: [],
      pendingSources: true,
      pendingDocuments: true,
    };
  },

  computed: {
    columns() {
      return [
        {
          title: "Locked",
          key: "locked",
          width: 80,
          render: (h, params) =>
            params.row.locked_at
              ? h("FFIcon", { attrs: { type: "check" } })
              : "",
        },
        {
          title: "Name",
          key: "name",
          width: 400,
          render: (h, params) =>
            h("div", [
              h("router-link", { attrs: { to: this.linkTo(params.row) } }, [
                h("span", params.row.name),
              ]),
            ]),
        },
        {
          title: "Country",
          key: "geo_entity",
          width: 200,
          render: (h, params) =>
            h("span", { name: "", ...params.row.geo_entity }.name),
        },
        {
          title: "Source",
          key: "source",
          width: 380,
          render: (h, params) =>
            h("span", { name: "", ...params.row.source }.name),
        },
        {
          title: "Cause",
          key: "displacement_type",
          width: 200,
        },
        {
          title: "Unit",
          key: "unit",
          width: 150,
        },
        {
          title: "Document",
          key: "document",
          width: 420,
          render: (h, params) =>
            h("span", { name: "", ...params.row.document }.name),
        },
      ];
    },
  },

  methods: {
    linkTo(dataset) {
      if (dataset.locked_at) {
        return `/tabular-datasets/${dataset.id}`;
      }
      return `/tabular-datasets/edit/${dataset.id}`;
    },
  },

  async created() {
    this.dataset = await getDatasetsByConditions();
  },

  watch: {
    async conditions() {
      this.dataset = await getDatasetsByConditions();
    },
  },
};
</script>

<style lang="css"></style>
